<div class="wm-m-slotinfo-container" attr.data-testing-id="new-project-slot-{{slot.id}}" [ngClass]="{'cursor-pointer': cursorPointer}">
  <wm-slot-icon [slot]="slot" [matchOverview]="showType"></wm-slot-icon>
  <div class="wm-m-slotprojectinfo-name-and-provider">
    <div class="wm-m-slotinfo-name" attr.data-testing-id="new-project-slot-{{slot.id}}-name">{{slot.name}}</div>
    @if (showType) {
      <div class="wm-m-slotinfo-type">{{getSlotTypeLabel()}}</div>
    }
  </div>
</div>
